<template>
  <div
    id="image-select"
    class="flex flex-col gap-4 px-5 py-3 bg-white rounded-lg w-[324px]">
    <div class="flex justify-between items-center">
      <p class="text-[#0F172A] text-base font-semibold font-simplerRegular">
        {{ $t('blocksSettings.image.add_image') }}
      </p>
      <button
        class="p-2 rounded-[10px] bg-secondary-100 hover:bg-secondary-200 transition-colors"
        @click="$emit('close')">
        <X :stroke-width="1" :size="16" />
      </button>
    </div>
    <ImageTool :id="props.id" v-model:src="imageSrc" />
  </div>
</template>

<script setup lang="ts">
import ImageTool from './ImageTool/ImageTool.vue';
import { X } from 'lucide-vue-next';
const props = defineProps<{
  id: string;
}>();

const imageSrc = defineModel<string>('src', { required: true });

defineEmits<{
  (e: 'close'): void;
}>();
</script>
